import { gql } from 'graphql-tag'

export const UPSERT_NOTIFICATION_PREFERENCE = gql`
  mutation upsertNotificationPreference(
    $consumerId: ID!
    $notificationPreferenceInput: UpdateNotificationPreferenceInput!
  ) {
    upsertNotificationPreference(consumerId: $consumerId, notificationPreferenceInput: $notificationPreferenceInput) {
      channel
    }
  }
`
